import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/common/ui/Button";
import {
  FileInput,
  NumberInput,
  RadioInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import { history } from "../../_helpers";
import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import { eCardAction } from "../../_store";
import { eCardCategorySchema, eCardSchema } from "../../validation/eCardSchema";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../components/common/ui/Loader";
import CustomPhoto from "../../composables/CustomPhoto";
import { getStoredValue } from "../../_helpers/storagehelper";

function UploadECard() {
  const dispatch = useDispatch();
  const location = useLocation();

  const fileInputRef = useRef(null);

  const { REACT_APP_API_IMAGE_URL } = process.env;

  const { monthList, eCardViewPermissionForRadio } = useSelector(
    (x) => x?.dropdownOptions
  );

  const { categoriesForDropDown, EcardDetailsForEdit, loading } = useSelector(
    (x) => x?.ecard
  );

  const { Status } = useSelector((state) => state.dropdownOptions);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageForCategory, setErrorMessageForCategory] = useState({});
  const [closeModalPopup, setCloseModalPopup] = useState(false);
  const [createEcardData, setcreateEcardData] = useState({
    ecardId: 0,
    ecardName: "",
    ecardImage: {},
    ecardFilePath: "",
    ecardFileName: "",
    categoryId: 0,
    isActive: 1,
    visibleTo: 3,
    createdBy: getStoredValue("user")?.ManagementUserID || 0,
    base64file: "",
  });

  const [createCategoryData, setCreateCategoryData] = useState({
    categoryId: 0,
    categoryName: "",
    fromMonth: 0,
    toMonth: 0,
    monthRange: "",
    costCategory: "",
    isActive: 1,
    createdBy: getStoredValue("user")?.ManagementUserID || 0,
  });

  const [isZoom, setIsZoom] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [popupLoader, setPopupLoader] = useState(false);
  // const [resetKey, setResetKey] = useState(Date.now());

  const cardID = location?.state?.cardID ? location?.state?.cardID : 0;
  const isEdit = location?.state?.isEdit ? location?.state?.isEdit : 0;
  // const { cardID, isEdit } = location.state || {};


  useEffect(() => {
    dispatch(eCardAction?.resetECardDetails());
    getCategoriesForDropDown();
  }, []);

  useEffect(() => {
    if (cardID === 0) return;
    dispatch(eCardAction?.getEcardDetailsForEdit(cardID))
      .then((result) => {
        const rowDetail = result?.payload;
        const payload = { ...createEcardData };
        payload.ecardId = rowDetail?.EcardId;
        payload.ecardName = rowDetail?.EcardName ? rowDetail?.EcardName : "";
        payload.categoryId = rowDetail?.CategoryId;
        payload.isActive = rowDetail?.IsActive;
        payload.ecardFileName = rowDetail?.EcardFileName;
        payload.visibleTo = rowDetail?.VisibleTo;
        payload.ecardFilePath = rowDetail?.EcardFilePath;
        payload.ecardImage.name = rowDetail?.EcardFileName;
        payload.ecardImage.type = "image/jpeg";
        payload.ecardImage.size = 2097152;
        payload.createdBy =
          getStoredValue("user")?.ManagementUserID || 0;
        setcreateEcardData(payload);
      })
      .catch((err) => {
        showToastNotification("Failed to get E-Card Details", "error");
      });
  }, [cardID]);

  const handleCategoryNameChange = (e) => {
    const { name, value } = e?.target;
    if (value.startsWith(" ")) return;
    const isValid = /^[a-zA-Z0-9 ']*$/.test(value);
    if (!isValid) return;
    const data = { ...createEcardData };
    data[name] = value;
    setcreateEcardData(data);
  };

  const getCategoriesForDropDown = () => {
    dispatch(eCardAction?.getCategoriesForDropDown());
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "44px",
      borderColor:
        errorMessage && errorMessage["categoryId"] ? "red" : base.borderColor,
      "&:hover": {
        borderColor:
          errorMessage && errorMessage["categoryId"] ? "red" : base.borderColor,
      },
      boxShadow: state.isFocused
        ? errorMessage && errorMessage["categoryId"]
          ? "0 0 5px 1px red"
          : base.boxShadow
        : null,
      fontSize: "15px",
      fontWeight: 400,
      backgroundColor: "" ? "#e9ecef" : "#ffffff",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "15px",
      overflow: "auto",
      fontWeight: 400,
      zIndex: 1050,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Ensures the dropdown stays above modal
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
  };
  const handleMonthChange = (e, input) => {
    const data = { ...createCategoryData };
    data[input] = e?.value ? e?.value : 0;
    const monthRange = createMonthRange(
      data?.fromMonth ? data?.fromMonth : 1,
      data?.toMonth ? data?.toMonth : 12
    );
    data["monthRange"] = monthRange.toString();
    setCreateCategoryData(data);
    return;
  };

  function createMonthRange(from, to) {
    const range = [];
    let current = from;

    while (true) {
      range.push(current);
      if (current === to) break;
      current = (current % 12) + 1;
    }

    return range;
  }

  const showToaster = (response) => {
    switch (response?.IsSucceed) {
      case 1:
        showToastNotification("E-Card uploaded successfully.", "success");
        history.navigate("/Admin/E-Cards");
        break;

      case 2:
        showToastNotification(
          "E-Card Details Updated successfully.",
          "success"
        );
        history.navigate("/Admin/E-Cards");
        break;

      case -2:
        showToastNotification("E-Card Name Already exist", "warning");
        break;

      default:
        break;
    }
  };

  // const handleFileChange = (e) => {
  //   const { files } = e?.target;
  //   // if (files.length === 0) return;
  //   if (files?.length === 0) {
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       ecardImage: "Please upload E-Card.",
  //     }));
  //     const data = { ...createEcardData };
  //     data["ecardImage"] = {};
  //     data["ecardFilePath"] = "";
  //     data["ecardFileName"] = "";
  //     setcreateEcardData(data);
  //     return;
  //   }
  //   const type = files?.[0]?.type;
  //   const name = files?.[0]?.name;

  //   const typeList = ["image/jpeg", "image/png", "image/jpg"];
  //   const size = files?.[0]?.size;
  //   if (typeList.includes(type) && size > 2 * 1024 * 1024) {
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       ecardImage: "File size should not exceed 2MB.",
  //     }));
  //   }
  //   if (!typeList.includes(type)) {
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       ecardImage: "Invalid Image Format.",
  //     }));
  //     const data = { ...createEcardData };
  //     data["ecardImage"] = { type: type, size: size, name: name };
  //     setcreateEcardData(data);
  //     return;
  //   }
  //   setErrorMessage((prev) => ({
  //     ...prev,
  //     ecardImage: "",
  //   }));
  //   const file = files && files[0];
  //   const fileName = file?.name;
  //   const fileSize = file?.size;
  //   const fileType = file?.type;
  //   const payload = { ...createEcardData };

  //   payload.ecardImage.size = fileSize;
  //   payload.ecardImage.type = fileType;
  // const extension = fileName
  //   .substring(fileName.lastIndexOf(".") + 1)
  //   .toLowerCase();

  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     const base64String = reader.result;
  //     payload.base64file = base64String;
  //     const lastIndex = fileName?.lastIndexOf(".");
  //     const removedExtensionTxt = [...fileName].splice(0, lastIndex).toString();
  //     const removeWhitSpace = removedExtensionTxt.replace(
  //       /[+\-\/,?*:;<>@#$%^&!~\s]/g,
  //       ""
  //     );
  //     const removedExtraTxt = [...removeWhitSpace].splice(0, 100).join("");
  //     payload.ecardImage.name = removedExtraTxt + "." + extension;
  //     payload.ecardFileName = removedExtraTxt + "." + extension;
  //     payload.ecardFilePath = "";
  //   };
  //   setcreateEcardData(payload);
  // };

  const handleFileChange = (e) => {
    const { files } = e?.target;

    if (files?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        ecardImage: "Please upload E-Card.",
      }));
      setcreateEcardData((prev) => ({
        ...prev,
        ecardImage: {},
        ecardFilePath: "",
        ecardFileName: "",
        base64file: "",
      }));
      return;
    }

    const file = files[0];
    const { name, size } = file;
    const type = file.type?.trim() || "dummy";
    const typeList = ["image/jpeg", "image/png", "image/jpg"];
    if (!typeList.includes(type)) {
      setErrorMessage((prev) => ({
        ...prev,
        ecardImage: "Please upload a valid image file (JPEG/PNG/JPG).",
      }));
      setcreateEcardData((prev) => ({
        ...prev,
        ecardImage: { type, size, name },
        base64file: "",
      }));
      return;
    }

    if (size > 2 * 1024 * 1024) {
      setErrorMessage((prev) => ({
        ...prev,
        ecardImage: "File size should not exceed 2MB.",
      }));
      return;
    }

    setErrorMessage((prev) => ({
      ...prev,
      ecardImage: "",
    }));

    const extension = name.substring(name.lastIndexOf(".") + 1).toLowerCase();
    const reader = new FileReader();

    reader.onload = () => {
      const base64String = reader.result;
      const lastIndex = name.lastIndexOf(".");
      const nameWithoutExtension = name.substring(0, lastIndex);

      const cleanedName = nameWithoutExtension.replace(
        /[+\-\/,?*:;<>@#$%^&!~\s]/g,
        ""
      );
      const finalName = cleanedName.slice(0, 100) + "." + extension;

      const payload = {
        ...createEcardData,
        base64file: base64String,
        ecardImage: {
          name: finalName,
          type,
          size,
        },
        ecardFileName: finalName,
        ecardFilePath: "",
      };

      setcreateEcardData(payload);
    };

    reader.readAsDataURL(file);
  };


  const handleChange = (e, select) => {
    const payload = { ...createEcardData };
    if (select) {
      payload[select] = e?.value !== undefined ? e?.value : 0;
      setcreateEcardData(payload);
      setErrorMessage((prev) => ({
        ...prev,
        [select]: "",
      }));
      return;
    }
    const { name, value } = e.target;
    payload[name] = parseInt(value);
    setcreateEcardData(payload);
  };

  const handleCategoryChange = (e) => {
    const { name, value } = e.target;

    if (value.startsWith(" ")) return;

    if (name === "costCategory") {
      const regex = /^\d*\.?\d*$/;
      if (!regex.test(value)) return;
    }
    setCreateCategoryData((prevState) => ({
      // ...prevState,
      // [name]: name === "isActive" ? parseInt(value) : value,
      ...prevState,
      [name]: name === "isActive" ? parseInt(value) : value,
      ...(name === "costCategory" && {
        costCategory: value === null || value === "" ? "" : parseFloat(value),
      }),
    }));
  };

  const showToasterMessage = (response) => {
    switch (response?.IsSucceed) {
      case 1:
        showToastNotification(
          "E-Card Category created successfully.",
          "success"
        );

        handleCategoryReset();
        setCloseModalPopup(false);
        closeBootstrapModal();

        setTimeout(() => {
          getCategoriesForDropDown();
        }, 300);
        //getCategoriesForDropDown();
        break;
      case -2:
        showToastNotification("E-Card Category already exsists.", "warning");
        setCloseModalPopup(false);
        // setTimeout(() => {
        //   window.location.reload();
        // }, 500);
        // getCategoriesForDropDown();
        break;

      default:
        showToastNotification("Failed to create E-Card Category", "error");
        window.location.reload();
        break;
    }
  };
  const closeBootstrapModal = () => {
    document.body.classList.remove('modal-open');
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };


  const submitForAddCategory = (e) => {
    e?.preventDefault();
    const requestData = { ...createCategoryData };
    requestData["costCategory"] =
      requestData?.costCategory === null || requestData?.costCategory === ""
        ? 0
        : requestData?.costCategory;
    requestData["isFrom"] = "QuickCategoryAdd";
    const { error } = eCardCategorySchema(requestData);
    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessageForCategory((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    setPopupLoader(true);
    dispatch(eCardAction?.createEcardCategory(requestData))
      .then((result) => {
        if (result?.payload) {
          setPopupLoader(false);
          showToasterMessage(result?.payload);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create E-Card Category", "error");
      });
  };

  const handleZoom = () => {
    setIsZoom(true);
  };

  const handleValidation = (e, name) => {
    const requestData = { ...createEcardData };

    const { error } = eCardSchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "",
      }));
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const handleValidationForPopup = (e, name) => {
    const requestData = { ...createCategoryData };
    requestData["costCategory"] =
      requestData?.costCategory === null || requestData?.costCategory === ""
        ? 0
        : requestData?.costCategory;

    const { error } = eCardCategorySchema(requestData);
    // if (error?.details) {
    const fieldError = error?.details?.find((e) => e.path.toString() === name);
    setErrorMessageForCategory((prev) => ({
      ...prev,
      [name]: fieldError ? fieldError.message : "",
    }));
    // return;
    // }
    // const fieldError = error?.details?.find(
    //   (e) => e?.path?.toString() === name
    // );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const handleCloseIconInPopup = () => {
    setErrorMessageForCategory({});
    setCreateCategoryData({
      categoryId: 0,
      categoryName: "",
      fromMonth: 0,
      toMonth: 0,
      monthRange: "",
      costCategory: "",
      isActive: 1,
      createdBy: getStoredValue("user")
        ? getStoredValue("user").ManagementUserID
        : "",
    });
  };

  const UploadECardData = (e) => {
    e?.preventDefault();
    // return;
    const { error } = eCardSchema(createEcardData);
    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    const data = { ...createEcardData };
    data["createdBy"] =
      getStoredValue("user")?.ManagementUserID || 0;
    setcreateEcardData(data);

    dispatch(eCardAction?.uploadECard(data))
      .then((result) => {
        showToaster(result?.payload);
      })
      .catch((err) => {
        showToastNotification("Failed to update E-Card Details");
      });
  };

  const handleCategoryReset = () => {
    setErrorMessageForCategory({});
    setCreateCategoryData({
      categoryId: 0,
      categoryName: "",
      fromMonth: 0,
      toMonth: 0,
      monthRange: "",
      costCategory: "",
      isActive: 1,
      createdBy: getStoredValue("user")
        ? getStoredValue("user").ManagementUserID
        : "",
    });
  };

  const handleReset = () => {
    setErrorMessage({});
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input
    }
    const reset = { ...createEcardData };
    reset.ecardId = EcardDetailsForEdit?.EcardId
      ? EcardDetailsForEdit?.EcardId
      : 0;
    reset.ecardName = EcardDetailsForEdit?.EcardName
      ? EcardDetailsForEdit?.EcardName
      : "";
    reset.ecardFileName = EcardDetailsForEdit?.EcardFileName
      ? EcardDetailsForEdit?.EcardFileName
      : "";
    if (EcardDetailsForEdit && Object.keys(EcardDetailsForEdit).length > 0) {
      reset.ecardImage = {
        name: EcardDetailsForEdit?.EcardFileName || "",
        type: EcardDetailsForEdit?.EcardFileName ? "image/jpeg" : "",
        size: EcardDetailsForEdit?.EcardFileName ? 2097152 : 0,
      };
    } else {
      reset.ecardImage = {};
    }
    reset.categoryId = EcardDetailsForEdit?.CategoryId
      ? EcardDetailsForEdit?.CategoryId
      : 0;
    reset.isActive =
      Object?.keys(EcardDetailsForEdit)?.length > 0
        ? EcardDetailsForEdit?.IsActive === 1
          ? 1
          : 0
        : 1;
    reset.visibleTo = EcardDetailsForEdit?.VisibleTo
      ? EcardDetailsForEdit?.VisibleTo
      : 3;
    reset.ecardFilePath = EcardDetailsForEdit?.EcardFilePath
      ? EcardDetailsForEdit?.EcardFilePath
      : "";
    reset.base64file = "";
    reset.createdBy =
      getStoredValue("user")?.ManagementUserID || 0;
    setcreateEcardData(reset);
  };

  if (loading) return <CustomLoader />;

  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 upload-e-card">
      <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap mb-2">
        <h2 className="form_title_uppercase text-color">{`${cardID > 0 ? "Edit " : "Upload "
          }E-CARD`}</h2>
        <Button
          label="Back"
          type="button"
          variant="danger"
          status={"primary"}
          disabled={false}
          icon={"fa-solid fa-angle-left"}
          onClick={() => {
            history.navigate("/Admin/E-Cards");
          }}
        />
      </div>

      <div className="mt-2">
        <h4 className="inner-header-bg text-color">
          <i className="fa-solid fa-circle-info me-2"></i> E-Card Information
        </h4>
        <div>
          <form onSubmit={(e) => UploadECardData(e)}>
            <div className="row col-lg-12">
              <div className="mb-3 col-sm-6 col-lg-4">
                <TextInput
                  label="E-Card Name"
                  name="ecardName"
                  placeholder="Enter E-Card Name"
                  maxLength={50}
                  handleChange={(e) => {
                    handleCategoryNameChange(e);
                  }}
                  value={createEcardData?.ecardName}
                  required
                  errorMessage={errorMessage}
                  handleBlur={(e) => {
                    handleValidation(e, "ecardName");
                  }}
                />
              </div>

              <div className="mb-3 col-sm-6 col-lg-4">
                <div>
                  <label className="form-label col-form-label w-100 font-size-14 form-label-custom-visible">
                    Category <span className="text-danger">* </span>
                    <div className="d-inline-flex align-items-center gap-2 ml-2 ">
                      <i
                        className="fa fa-plus-circle fa-lg cursor-pointer font-size-18"
                        title="Add Category"
                        aria-hidden="true"
                        data-bs-toggle="modal"
                        data-bs-target="#add-Ecard-modal"
                      ></i>
                    </div>
                    <div className="float-right">
                      <i
                        className="fa fa-repeat cursor-pointer mx-2 font-size-18"
                        title="Refresh Category"
                        aria-hidden="true"
                        onClick={() => {
                          getCategoriesForDropDown();
                        }}
                      ></i>
                    </div>
                  </label>
                  <Select
                    className={`font-size-14`}
                    name="categoryId"
                    isLoading={loading}
                    id="categoryId"
                    styles={customStyles}
                    options={categoriesForDropDown}
                    onChange={(e) => {
                      handleChange(e, "categoryId");
                    }}
                    value={
                      categoriesForDropDown?.find(
                        (opt) => opt.value === createEcardData?.categoryId
                      ) || null
                    }
                    onBlur={(e) => {
                      handleValidation(e, "categoryId");
                    }}
                    isClearable={createEcardData?.categoryId !== 0}
                  />
                  {errorMessage &&
                    errorMessage["categoryId"] &&
                    Object?.keys(errorMessage).length > 0 && (
                      <div className="text-danger fw-700 fs-6">
                        {errorMessage &&
                          errorMessage["categoryId"] &&
                          errorMessage["categoryId"]}
                      </div>
                    )}
                </div>
              </div>

              <div className="mb-1 col-sm-6 col-lg-4">
                <FileInput
                  ref={fileInputRef}
                  label="E-Card"
                  name="ecardImage"
                  showImage={false}
                  accept={".jpg, .jpeg,"}
                  placeholder="Upload E-Card"
                  handleFileChange={(e) => {
                    handleFileChange(e);
                  }}
                  imageURL={
                    createEcardData?.base64file
                      ? createEcardData?.base64file
                      : createEcardData?.ecardFilePath
                        ? REACT_APP_API_IMAGE_URL + createEcardData?.ecardFilePath
                        : ""
                  }
                  required
                  errorMessage={errorMessage}
                  isEcardNotes
                  isZoom={true}
                  handleZoom={handleZoom}
                />
              </div>
            </div>

            <div className="row col-lg-12">
              <div className="mb-3 col-sm-6 col-lg-4">
                <RadioInput
                  label="Status"
                  name="isActive"
                  id="isActive"
                  options={Status}
                  selectedValue={createEcardData?.isActive}
                  // required
                  handleChange={(e) => {
                    handleChange(e);
                  }}
                  errorMessage={errorMessage}
                />
              </div>

              <div className="mb-3 col-sm-6 col-lg-4">
                <RadioInput
                  label="Visible To"
                  name="visibleTo"
                  id="visibleTo"
                  options={eCardViewPermissionForRadio}
                  selectedValue={createEcardData?.visibleTo}
                  // required
                  handleChange={(e) => {
                    handleChange(e);
                  }}
                  errorMessage={errorMessage}
                />
              </div>
            </div>

            <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
              <Button
                className="me-2"
                label={cardID === 0 ? "Upload" : "Update"}
                type="submit"
                variant="danger"
                status={"success"}
                disabled={false}
                icon={
                  cardID === 0
                    ? "fa-solid fa-floppy-disk"
                    : "fa-solid fa-pen-to-square"
                }
              />
              <Button
                className="me-2"
                label="Reset"
                type="button"
                variant="danger"
                status={"secondary"}
                disabled={false}
                icon={"fa-solid fa-rotate-right"}
                onClick={() => {
                  handleReset();
                }}
              />
            </div>

            <CustomPhoto
              // ecardFilePath
              imgsrc={
                createEcardData?.base64file
                  ? createEcardData?.base64file
                  : createEcardData?.ecardFilePath
                    ? REACT_APP_API_IMAGE_URL + createEcardData?.ecardFilePath
                    : ""
              }
              isZommImage={isZoom}
              setisZommImage={setIsZoom}
              rotation={rotation}
              setRotation={setRotation}
            />
          </form>
        </div>
      </div>
      <CommonModal
        modalId="add-Ecard-modal"
        title="ADD CATEGORY"
        //loader={popupLoader}
        handleCloseIcon={handleCloseIconInPopup} //for cross icons
        closeModalTrigger={closeModalPopup}
        bodyContent={
          <form
            className="d-flex flex-column gap-3"
            onSubmit={(e) => {
              submitForAddCategory(e);
            }}
          >
            <TextInput
              name="categoryName"
              label="Category Name"
              placeholder="Enter Category Name"
              maxLength={25}
              value={createCategoryData.categoryName}
              handleChange={(e) => {
                handleCategoryChange(e);
              }}
              required
              errorMessage={errorMessageForCategory}
              handleBlur={(e) => {
                handleValidationForPopup(e, "categoryName");
              }}
            />

            <SelectInput
              name="fromMonth"
              options={monthList}
              closeMenuOnSelect={true}
              isLoading={false}
              label="Start Month"
              placeholder="Select Month"
              handleChange={(e) => {
                handleMonthChange(e, "fromMonth");
              }}
              isClearable={createCategoryData?.fromMonth !== 0}
              value={createCategoryData?.fromMonth}
              required
              errorMessage={errorMessageForCategory}
              handleBlur={(e) => {
                handleValidationForPopup(e, "fromMonth");
              }}
            />

            <SelectInput
              name="toMonth"
              options={monthList}
              isMulti={false}
              closeMenuOnSelect={true}
              isDisabled={false}
              isLoading={false}
              label="End Month"
              placeholder="Select Month"
              isClearable={createCategoryData?.toMonth !== 0}
              handleChange={(e) => {
                handleMonthChange(e, "toMonth");
              }}
              value={createCategoryData?.toMonth}
              required
              errorMessage={errorMessageForCategory}
              handleBlur={(e) => {
                handleValidationForPopup(e, "toMonth");
              }}
            />

            <NumberInput
              label="Category Cost ($)"
              name="costCategory"
              placeholder="1.00"
              handleChange={(e) => {
                handleCategoryChange(e);
              }}
              value={
                createCategoryData.costCategory === null
                  ? ""
                  : createCategoryData.costCategory
              }
              maxLength={5}
              errorMessage={errorMessageForCategory}
              handleBlur={(e) => {
                handleValidationForPopup(e, "costCategory");
              }}
              maxValue={99}
            />

            <div className="d-flex">
              <Button
                className="me-2 "
                label="Add"
                type="submit"
                variant="danger"
                status={"success"}
                disabled={popupLoader}
                icon={"fa-solid fa-floppy-disk"}
              />
              <Button
                className="me-2 "
                label="Reset"
                type="reset"
                variant="danger"
                status={"secondary"}
                disabled={false}
                icon={"fa-solid fa-rotate-right"}
                onClick={() => {
                  handleCategoryReset();
                }}
              />
            </div>
          </form>
        }
        modalSize="modal-md"
      // footerContent={
      //   <button
      //     className="btn button-primary"
      //     data-bs-dismiss="modal"
      //     // onClick={() => {
      //     //   handleResetPageandRowCount();
      //     // }}
      //   >
      //     Close
      //   </button>
      // }
      />
    </div>
  );
}

export default React.memo(UploadECard);
